import { defineStore } from 'pinia';

export const useToastStore = defineStore('baseToast', {
  state: () => ({
    toasts: []
  }),
  
  actions: {
    addToast(toast) {
      const id = Date.now();
      const newToast = {
        id,
        type: toast.type || 'info',
        message: toast.message,
        duration: toast.duration || 3000
      };
      
      this.toasts.push(newToast);
      
      // Auto-remove after duration
      setTimeout(() => {
        this.removeToast(id);
      }, newToast.duration);
      
      return id;
    },
    
    removeToast(id) {
      const index = this.toasts.findIndex(toast => toast.id === id);
      if (index !== -1) {
        this.toasts.splice(index, 1);
      }
    }
  }
});